import * as fromInstructor from './instructor.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const { selectAll } = fromInstructor.instructorAdapter.getSelectors();

export const selectInstructorState = createFeatureSelector<fromInstructor.State>(fromInstructor.instructorFeatureKey);

export const selectAllInstructors = createSelector(selectInstructorState, selectAll);

export const selectInstructorsByName = (searchString: string) =>
    createSelector(selectAllInstructors, (entities) => entities.filter((entity) => entity.name?.toLowerCase().includes(searchString.toLowerCase())));
